module.exports = __webpack_public_path__ + "static/img/12.302760d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/12.png
// module id = J6Qo
// module chunks = 0